import services from './services';
import {
    lg,
    cloneDeep,
    util,
    isCorrectVal,
    isDate
} from 'utils';
import {
    GetProvinces,
    GetCitys,
    GetAreas,
    GetAgentList,
    GetParmConfig, //寄送，支付接口
    GetProductClass,
    GetAgentConsigneeList,
    Consignee_Add,
    GetEmployList,
    ConsigneeSetDefault
} from '@api/commonApi.js';
import NProgress from 'nprogress';
import viewPhoto from 'src/common/js/viewPhoto';
import $http from '$http';
import chooseDialog from "@pages/Order/MeetOrder/components/chooseDialog/index.vue" //选择代理商、园所弹窗
import schoolList from "../schoolList/index.vue" //园所弹窗
import AddressDialog from "../AddressDialog/index.vue" // 选择收货地址弹窗
import addClass from "../addClass/index.vue" // 创建班级
import optOpenClassDialog from '@pages/Order/components/optOpenClassDialog/index.vue'; //添加幼儿园（原开课申请）
import payTypeInfo from '@pages/Order/MeetOrder/components/payTypes/index.vue'; //支付方式

export default {
    mixins: [services],
    components: {
        chooseDialog,
        AddressDialog,
        optOpenClassDialog,
        payTypeInfo,
        addClass,
        schoolList
    },
    props: {
        value: {
            type: Boolean,
            default: null
        },
    },
    created() {


    },
    data() {
        return {
            up1: null,
            up2: null,
            up3: null,
            up4: null,
            num: 1,
            loading: false,
            agent: '',
            school: '',
            form: this.getSubmitFormData(),
            netWorkData: this.getSchoolNetWork(),
            SchoolConsigneeList: [],
            ConsigneeList: '', //收货地址
            ConsigneeListName: '', //联系人及电话
            dialogVisible: false, //没有园所提示的弹窗
            AddDialogVisible: false,
            showData: this.getShowData(), //弹窗传参
            pageIndex: 1,
            pageSize: 10,
            minNum: 1,
            maxNum: Infinity,
            isDelShow: [false],
            payList: [{}],
            orderPackages: [{
                Id: 504,
                label: "D55套餐"
            }, {
                Id: 503,
                label: "D65套餐"
            }],
            ClassLists: [],
            AgentLists: [],
            openClassList: [{
                ClassId: '',
                ClassLists: this.ClassLists
            }],
            StepId: 1, //1为第一步，2为园所第二步
            stockTotalNum: 0, //总库存量
            stockNum: 0, //使用经销库存发货数736
            labelName: '代理商',
            storeAgentStyle: '',
            Customer: '',
            IsAreaRole: 0,
            storageNetwork: false, //用来判断是否切换园所
            storeChooseAgentId: '',
            maxNum: 0,
            schoolConsignee: this.getSchoolConsignee()
        }
    },
    methods: {
        getSubmitFormData() {
            return cloneDeep({
                "ClassNum": 0,
                "ClassList": [],
                "OrderPrice": 0,
                "SchoolConsigneeId": 0,
                "OrderId": 0,
                "TimeStamp": 0,
                "PackageId": '',
                "SendMode": 223,
                "PayMode": 222,
                "ListMeetPay": [],
                "GoodsList": [],
                "AgentId": 0,
                "SchoolId": 0,
                "AgentStyle": '',
                "ContractId": 0,
                "ChooseAgentId": '',
                "IsUseAgentStock": "",
                OrderRemark: ''
            });
        },
        // 园所提交信息
        getSchoolNetWork() {
            return cloneDeep({
                "SchoolId": 0,
                "BandWidth": 0,
                "IsSpecilLine": 0,
                "NetworkOperator": [],
                "NetworkType": [],
                "SchoolPics": [],
                "ProveType": 0,
                "ProvePics": [],
                "ContractPices": [],
                "CooperationPics": [],
                "ContractType": 0,
                "Distance": '',
                "Engineer": ''
            })
        },
        // 园所地址
        getSchoolConsignee() {
            return cloneDeep({
                ConsigneeProvId: '',
                ConsigneeCityId: '',
                ConsigneeAreaId: '',
                Consignee: '',
                ConsigneeAddress: '',
                ConsigneeTel: ''
            })
        },
        getShowData() {
            return cloneDeep({
                SchoolId: 0,
                title: '',
                isReadOnly: false,
                IsEdit: 0 //0可编辑园所所有信息

            });
        },
        //初始化数据
        initData() {
            this.form = this.getSubmitFormData()
            this.showData = this.getShowData()
            this.netWorkData = this.getSchoolNetWork()
            this.schoolConsignee = this.getSchoolConsignee()
            this.school = ""
            this.agent = ""
            this.ConsigneeList = ''
            this.ConsigneeListName = ''
            this.payList = [{}]
            this.StepId = 1
            this.stockTotalNum = 0
            this.storeAgentStyle = ''
            this.IsAreaRole = 0
            this.storageNetwork = false
            this.storeChooseAgentId = ''
        },
        show(options) {
            this.initData();
            this.AddDialogVisible = true
            this.showData.title = options.title
            this.openClassList = [{
                ClassId: '',
                ClassLists: this.ClassLists
            }]

            if (options.isReadOnly) {
                this.showData.isReadOnly = options.isReadOnly
            }

            if (this.up1) {
                this.up1.uploaderList[0].destroy();
            }

            if (this.up2) {
                this.up2.uploaderList[0].destroy();
            }

            if (this.up3) {
                this.up3.uploaderList[0].destroy();
            }

            if (this.up4) {
                this.up4.uploaderList[0].destroy();
            }

            this.initUploadfn();
            if (options.OrderId) {
                this.GetById(options.OrderId)
            }

        },
        // 重置代理商信息，园所信息，收货地址
        initData2() {
            this.form.SchoolId = 0
            this.school = ""
            this.form.AgentId = 0
            this.agent = ""
            this.form.SchoolConsigneeId = 0
            this.ConsigneeList = ''
            this.ConsigneeListName = ''
            this.form.ClassNum = 1
            this.loading = false
            this.ClassLists = []
            this.openClassList = [{
                ClassId: '',
                ClassLists: this.ClassLists
            }]
            this.form.ChooseAgentId = ''
            this.AgentLists = []
            this.stockNum = 0
        },
        // 选择归属方
        changeAgentStyle(val) {
            if (val !== this.storeAgentStyle) {
                // 切换修改清空代理商信息
                this.initData2()
            }
            if (val == 2) {
                this.labelName = '代理商'
            } else if (val == 1) {
                this.labelName = '业务员'
            }
        },
        // 开班数
        changeNum(val) {
            if (this.form.PackageId !== '' && this.form.ChooseAgentId !== '') {
                // 获取经销商库存数量
                this.GetAgentPushRentInfo()
            }
            let len = this.openClassList.length

            if (val > len) {
                // 加
                this.openClassList.push({
                    ClassId: '',
                    ClassLists: this.ClassLists
                })
            } else {
                // 减
                this.openClassList.pop()
            }


        },
        changeVal(index) {


        },
        addFn() {
            this.payList.push({})
            this.isDelShow.push(true)
        },
        delPayFn(item) {
            this.payList.splice((item.index - 1), 1);

        },
        // 创建班级
        addClass() {
            if (this.form.SchoolId == 0) {
                this.$notify({
                    title: '警告',
                    message: '请先选择园所',
                    type: 'warning'
                });
            } else {
                this.$refs.refAddClass.show({
                    title: '创建班级',
                    SchoolId: this.form.SchoolId
                })
            }

        },
        getClassList() {
            this.ZqwPlatform_GetClassList(this.form.SchoolId)
        },
        add() {
            this.addClass()
            this.dialogVisible = false
        },
        other() {
            this.chooseSchool()
            this.dialogVisible = false

        },
        //添加幼儿园
        addSchool() {
            if (this.form.AgentId == 0) {
                this.$notify({
                    title: '警告',
                    message: '请先选择代理商',
                    type: 'warning'
                });
            } else {
                this.$refs.refoptOpenClassDialog.show({
                    AgentId: this.form.AgentId,
                    isAdd: true,
                    SchoolCome: 5,
                    isShowImg: false
                })
            }
        },
        // 选择套餐
        changePackage(val) {
            if (val !== '' && this.form.SchoolId !== 0 && this.form.AgentStyle == 1) {
                // 归属方非代理商
                this.GetAgentBySchoolId(this.form.PackageId, this.form.SchoolId)
            }
            if (this.form.ChooseAgentId !== '' && val !== '') {
                // 获取经销商库存数量
                this.GetAgentPushRentInfo()
            }

        },
        // 是否使用经销商发货
        changeIsUseAgentStock(val) {
            if (val == 1 && this.form.AgentStyle == 2) {
                this.AgentLists = []
                this.form.ChooseAgentId = this.form.AgentId
                this.AgentLists.push({
                    Id: this.form.AgentId,
                    Customer: this.Customer
                })
            } else {
                this.form.ChooseAgentId = ''
                this.AgentLists = []
                if (this.form.AgentStyle == 1) {
                    if (this.storeChooseAgentId !== 0) {
                        this.form.ChooseAgentId = this.storeChooseAgentId
                    }

                    this.GetAgentBySchoolId(this.form.PackageId, this.form.SchoolId)
                }

            }
        },
        // 选择库存代理商
        changeAgentId(val) {
            if (this.form.PackageId !== '' && val !== '') {
                // 获取经销商库存数量
                this.GetAgentPushRentInfo()
            }
        },
        getSchoolName(item) {
            //添加幼儿园后默认选中当前添加的幼儿园
            //item.SyncSchoolId存在则显示同步幼儿园后数据
            if (this.form.AgentStyle == 1) {
                // 业务员新增园所验证是否是属于所属区域的园所
                this.CheckSchoolAreaRole(item.SchoolId, this.form.AgentId)
            }
            this.$nextTick(() => {
                if (this.IsAreaRole !== 0) {
                    this.form.ClassNum = 1
                    this.ClassLists = [] //班级列表置空
                    this.form.ClassList = []
                    this.openClassList = [{
                        ClassId: '',
                        ClassLists: this.ClassLists
                    }]
                    this.school = item.SchoolName + '  ' + item.PrincipalName + '  ' + item.PhoneNo
                    if (this.form.SchoolId !== item.SchoolId && this.form.SchoolId !== 0) {
                        this.storageNetwork = true
                    }
                    this.form.SchoolId = item.SchoolId
                    this.getSchoolConsigneeList(this.form.SchoolId)
                    this.ZqwPlatform_GetClassList(this.form.SchoolId)
                    if (this.form.PackageId !== '' && this.form.AgentStyle == 1) {
                        this.form.ChooseAgentId = ''
                        this.AgentLists = []
                        this.GetAgentBySchoolId(this.form.PackageId, this.form.SchoolId)
                    }
                } else if (this.form.AgentStyle == 1 && this.IsAreaRole == 0) {
                    this.$notify({
                        title: '警告',
                        message: '该园所不在所属业务员所属区域',
                        type: 'warning'
                    });
                }
            })



        },
        // 获取组件chooseDialog 值
        getDialogList(item) {
            // 切换代理商或园所重置资源包数据
            this.agent = item.Customer + '   ' + item.Address + '   ' + item.AgentTel
            this.form.AgentId = item.Id
            this.school = ''
            this.form.SchoolId = 0
            this.form.ClassNum = 1
            this.ClassLists = [] //班级列表置空
            this.openClassList = [{
                ClassId: '',
                ClassLists: this.ClassLists
            }]
            this.ConsigneeList = ''
            this.ConsigneeListName = ''
            this.AgentLists = []
            if (this.form.AgentStyle == 2) {
                this.AgentLists.push(item)
                this.Customer = item.Customer
                this.form.ChooseAgentId = item.Id
            }
            if (item.HasSchool !== 1 && this.form.AgentStyle == 2) {
                this.$alert('该代理商名下没有幼儿园！', '提示', {
                    confirmButtonText: '确定',
                    callback: action => {

                    }
                });

            }
        },
        //获取选择弹窗收货地址
        getAddress(item) {
            this.schoolConsignee.ConsigneeProvId = item.ConsigneeProvince
            this.schoolConsignee.ConsigneeCityId = item.ConsigneeCity
            this.schoolConsignee.ConsigneeAreaId = item.ConsigneeArea
            this.schoolConsignee.ConsigneeAddress = item.ConsigneeAdress
            this.schoolConsignee.Consignee = item.Consignee
            this.schoolConsignee.ConsigneeTel = item.ConsigneeTel

            this.ConsigneeList = item.ConsigneeProvinceName + '  ' + item.ConsigneeCityName + '  ' + item.ConsigneeAreaName + '  ' + item.ConsigneeAdress
            this.ConsigneeListName = item.Consignee + '  ' + item.ConsigneeTel

        },
        // 选择代理商
        chooseAgent() {
            if (this.form.AgentStyle == '') {
                this.$notify({
                    title: '警告',
                    message: '请先选择归属方',
                    type: 'warning'
                });
                return;
            }
            this.$refs.chooseDialog.show({
                title: '选择代理商',
                isCommon: true,
                AgentStyle: this.form.AgentStyle
            });

        },
        //选择园所
        chooseSchool() {
            if (this.form.AgentId == 0) {
                this.$notify({
                    title: '警告',
                    message: '请先选择代理商',
                    type: 'warning'
                });
            } else {
                this.$refs.refschoolList.show({
                    title: '选择园所',
                    AgentId: this.form.AgentId,
                    AgentType: this.form.AgentStyle

                });

            }

        },
        getSchoolItem(item) {
            this.form.ClassNum = 1
            this.ClassLists = [] //班级列表置空
            this.form.ClassList = []
            this.openClassList = [{
                ClassId: '',
                ClassLists: this.ClassLists
            }]
            this.school = item.SchoolName + '   ' + item.PrincipalName + '   ' + item.PhoneNo
            if (this.form.SchoolId !== item.Id && this.form.SchoolId !== 0) {
                this.storageNetwork = true
            }
            this.form.SchoolId = item.Id

            this.getSchoolConsigneeList(this.form.SchoolId) //点击园所之后获取默认收货地址
            this.ZqwPlatform_GetClassList(this.form.SchoolId)
            if (this.form.PackageId !== '' && this.form.AgentStyle == 1) {
                this.GetAgentBySchoolId(this.form.PackageId, this.form.SchoolId)

            }
        },
        //修改园所收货地址
        changeAddress() {
            this.$nextTick(() => {
                this.$refs.AddressDialog.show({
                    SchoolId: this.form.SchoolId,
                    address: this.schoolConsignee,
                    Id: this.form.SchoolConsigneeId
                });
            })

        },
        nextStep() {
            // 下一步
            // 判断订单信息
            this.form.OrderPrice = this.price;

            // 支付方式
            this.form.ListMeetPay = []
            // 物料
            this.form.GoodsList = []

            // 班级列表
            this.form.ClassList = []
            for (let i = 0; i < this.form.ClassNum; i++) {
                if (this.openClassList[i].ClassId !== '') {
                    this.form.ClassList.push(this.openClassList[i].ClassId)
                }
            }


            let rule = [{
                name: "归属方",
                value: this.form.AgentStyle,
                required: true,
                msg: '请选择归属方'
            }, {
                name: "所属代理商",
                value: this.agent,
                required: true,
                msg: '请选择所属代理商'
            }, {
                name: "开课园所",
                value: this.school,
                required: true,
                msg: '请选择开课园所'
            }, {
                name: "开课班级",
                value: this.form.ClassList,
                required: true,
                msg: '请选择开课班级'
            }, {
                name: "套餐",
                value: this.form.PackageId,
                required: true
            }, {
                name: "是否使用经销商库存发货",
                value: this.form.IsUseAgentStock,
                required: this.isShowStockArea,
                msg: '是否使用经销商库存发货'
            }, {
                name: "库存代理商",
                value: this.form.ChooseAgentId,
                required: this.form.IsUseAgentStock == 1,
                msg: '请选择使用库存代理商'
            }];

            var flag = util.checkForm({
                ele: this,
                rules: rule
            });

            if (!flag) {
                return;
            }

            if (this.form.ClassList.length !== this.form.ClassNum) {
                this.$notify({
                    title: '警告',
                    message: '请选择开课班级',
                    type: 'warning'
                });
                return;
            }
            let ProId = 0
            if (this.form.PackageId == 503) {
                ProId = 320
            } else if (this.form.PackageId == 504) {
                ProId = 333
            }
            this.form.GoodsList = [{
                ProId: 646,
                ProNum: 16 * this.form.ClassNum
            }, {
                ProId: ProId,
                ProNum: this.form.ClassNum
            }]
            if (!this.isShowStockArea) {
                this.form.IsUseAgentStock = ''
            }
            if (this.form.IsUseAgentStock == 1) {
                this.form.GoodsList.push({
                    ProId: 736,
                    ProNum: this.stockNum
                })
            } else {
                this.form.ChooseAgentId = ''
                this.stockNum = ''
            }
            for (let i = 0; i < this.payList.length; i++) {
                // 价格为0时不需要填写支付信息
                if (this.form.OrderPrice > 0) {
                    let data = this.$refs['payInfo' + (i + 1)][0].validate();
                    if (!data) {
                        return;
                    }
                    this.form.ListMeetPay.push(data);
                } else {
                    this.form.ListMeetPay = []
                }
            }
            // 判断是否提交相同的班级
            let arr = cloneDeep(this.form.ClassList)
            var nary = arr.sort();
            for (var i = 0; i < arr.length; i++) {
                if (nary[i] == nary[i + 1]) {
                    this.$notify({
                        title: '警告',
                        message: '不能存在相同的班级',
                        type: 'warning'
                    });
                    return;

                }
            }
            this.StepId = 2
            this.showData.title = '园所信息'
            this.netWorkData.SchoolId = this.form.SchoolId
            this.GetSchoolContractType(this.netWorkData.SchoolId)
        },
        // 返回上一步
        backFn() {
            this.StepId = 1
            this.showData.title = '新增D55/D65订单'
        },
        // 提交订单
        submit() {
            // 先提交园所合作信息 再提交订单信息
            let rule = [{
                name: "园所网络运营商",
                value: this.netWorkData.NetworkOperator,
                required: true,
                msg: '请选择园所网络运营商'
            }, {
                name: "园所网络情况",
                value: this.netWorkData.NetworkType,
                required: true,
                msg: '请选择园所网络情况'
            }, {
                name: "电视到宽带口距离多远",
                value: this.netWorkData.Distance,
                required: this.isShowD,
                msg: '请选择电视到宽带口距离多远'
            }, {
                name: "是否需要上门服务",
                value: this.netWorkData.Engineer,
                required: true,
                msg: '是否需要上门服务'
            }, {
                name: "园所照片",
                value: this.netWorkData.SchoolPics,
                required: true,
                msg: '请上传园所照片'
            }, {
                name: "签约方证明",
                value: this.netWorkData.ProveType,
                required: true,
                msg: '请选择签约方证明'
            }, {
                name: "签约方证明图片",
                value: this.netWorkData.ProvePics,
                required: true,
                msg: '请上传签约方证明图片'
            }, {
                name: "合同",
                value: this.netWorkData.ContractPices,
                required: true,
                msg: '请上传合同图片'
            }, {
                name: "开课申请表",
                value: this.netWorkData.CooperationPics,
                required: true,
                msg: '请上传开课申请表图片'
            }];
            var flag = util.checkForm({
                ele: this,
                rules: rule
            });

            if (!flag) {
                return;
            }
            if (this.netWorkData.ProveType == 2) {
                if (this.netWorkData.ProvePics.length < 2) {
                    this.$notify({
                        title: '警告',
                        message: '身份证需上传两张图片',
                        type: 'warning'
                    });
                    return;
                }
            }
            if (!this.isShowD) {
                this.netWorkData.Distance = ''
            }
            if (this.form.OrderId > 0) {
                // 修改
                this.UpdateSchoolContract()
            } else {
                // 新增
                this.AddSchoolContract()
            }

        },
        // 查看图片
        showImgView(img) {
            viewPhoto.show({
                showImgId: "", //指定id显示图片
                thumbList: [{
                    src: img.Url,
                    id: ""
                }]
            });
        },
        // 删除图片
        delC_Drawing(list, i) {
            list.splice(i, 1);
        },
        // 初始化上传图片组件
        initUploadfn() {
            this.$nextTick(() => {

                this.up1 = util.initUploader(this, this.SchoolPicsCtnId, this.SchoolPicsBtnId, (file) => {

                    this.netWorkData.SchoolPics.push(file);
                });

                this.up2 = util.initUploader(this, this.LicencePicsCtnId, this.LicencePicsBtnId, (file) => {
                    this.netWorkData.ProvePics.push(file);
                });
                this.up3 = util.initUploader(this, this.EquipPicsCtnId, this.EquipPicsBtnId, (file) => {
                    this.netWorkData.ContractPices.push(file);
                });
                this.up4 = util.initUploader(this, this.CooperationPicsCtnId, this.CooperationPicsBtnId, (file) => {

                    this.netWorkData.CooperationPics.push(file);
                });

            });

        },

    },
    computed: {
        // 判断是否显示库存发货模块
        isShowStockArea() {
            if (this.form.PackageId !== '' && this.school != '' && this.stockTotalNum > 0) {
                return true
            } else if (this.AgentLists.length > 0 && this.form.AgentStyle == 1) {
                //业务员
                return true
            } else {
                return false
            }
        },
        stockNumMax() {
            if (this.form.ClassNum > this.stockTotalNum) {
                return this.stockTotalNum
            } else if (this.form.ClassNum < this.stockTotalNum) {
                return this.form.ClassNum
            } else {
                return this.form.ClassNum
            }
        },
        isShowD() {
            if (this.netWorkData.NetworkType.indexOf(2) > -1) {
                return true
            } else {
                return false
            }
        },
        //资源包价格
        price() {
            let num = 0
            if (this.form.PackageId == 504) {
                num = 7000 * this.form.ClassNum
            } else if (this.form.PackageId == 503) {
                num = 9800 * this.form.ClassNum
            }

            return num
        },
        materiel() {
            if (this.form.PackageId == 503) {
                return [{
                    ProId: 320,
                    ProName: '65寸在线教室终端',
                    ProNum: this.form.ClassNum
                }]
            } else if (this.form.PackageId == 504) {
                return [{
                    ProId: 333,
                    ProName: '55寸在线教室终端',
                    ProNum: this.form.ClassNum
                }]
            }

        },
        courses() {
            // 课程
            return [{
                ProId: 646,
                ProName: '2018Q2体验课',
                ProNum: 16 * this.form.ClassNum
            }]

        },
        // 上传图片Id
        SchoolPicsCtnId() {
            return 'SchoolPicsCtnId-' + new Date().getTime();
        },
        SchoolPicsBtnId() {
            return 'SchoolPicsBtnId-' + new Date().getTime();
        },
        LicencePicsCtnId() {
            return 'LicencePicsCtnId-' + new Date().getTime();
        },
        LicencePicsBtnId() {
            return 'LicencePicsBtnId-' + new Date().getTime();
        },
        CooperationPicsCtnId() {
            return 'CooperationPicsCtnId-' + new Date().getTime();
        },
        CooperationPicsBtnId() {
            return 'CooperationPicsBtnId-' + new Date().getTime();
        },
        EquipPicsCtnId() {
            return 'EquipPicsCtnId-' + new Date().getTime();
        },
        EquipPicsBtnId() {
            return 'EquipPicsBtnId-' + new Date().getTime();
        },
    },
}


// WEBPACK FOOTER //
// ./src/pages/SchoolOrder/components/addD55Order/vm.js